import React, { Suspense, lazy } from 'react';
import PageLoader from './components/PageLoader';

// Lazy load the main component
const SalesPartnerRegistration = lazy(() => import('./pages/SalesPartnerRegistration'));

function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <SalesPartnerRegistration />
    </Suspense>
  );
}

export default App;
